import React, { useEffect, useState } from 'react'
import BreadCrumbs from '../../../../components/BreadCrumbs'
import { Card, CardBody, Row, Col, Label, CardHeader } from "reactstrap";
import ControlledRowTextField from '../../../../components/ControlledRowTextField';
import { Controller, useForm } from 'react-hook-form';
import IMGUploadComponent from '../../../../components/IMGUploadComponent';
import Select from "react-select";
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useCreatePromotionMutation, useLazyGetPromotionTypeListQuery, useUploadPromotionLogoFileExtntionHttpsMutation } from '../../../../redux/services/promotionService';
import ButtonComponent from '../../../../components/ButtonComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { uploadImage } from '../../../../components/imageUploadCompont';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";
import { MenuTypeForMenu } from '../../../../constants/constans';
import { customFilterOption } from '../../../../utility/Utility';
import { Button, Table } from 'react-bootstrap';
import ControlledSelect from '../../../../components/ControlledSelect';
import { useLazyGetRestaurantFilterTagsQuery } from '../../../../redux/services/menuItemService';
import LoadingMessage from '../../../../components/LoadingMessage';
import { ApplyTypes } from '../../../../constants/constans';
import { useNormalizedMenuItems } from '../../../../hooks/normalizesMenuItemHook';


interface ItemType {
  type: string;
  id: string;
}

interface FormData {
  title?: string;
  description?: string;
  type: string;
  subType: string;
  code: string;
  value: number;
  expiresAt: string;
  minimumBillTotal: number;
  pointsToRupeeConversionRate: number;
  rupeeToPointConversionRate: number;
  appliedTo: string;
  isPublic: boolean;
  items: ItemType[];
  filterTags: string[];
}

interface PromotionTypeInterface {
  value: string;
  label: string;
}

interface MenuTypeOption {
  value: string;
  label: string;
}

interface ItemOptionType {
  displayName: string;
  price: number;
  id: string;
  imageUrl: string;
  itemType: string;
  allergenInformation?: string[];
  foodAttributes?: string[];
}

const AddPromotion = () => {
  const navigate = useNavigate();

  const restaurantId: string = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id
  );

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormData>();

  const [uploadedImgDetails, setUploadedImgDetails] = useState({
    imgSrc: "",
    formData: "",
    fileExtention: "",
  });

  const [isSaving, setIsSaving] = useState(false);

  const [selectedPrmotionType, setSelectedPromotionType] =
    useState<PromotionTypeInterface | null>(null);

  const [selectedSubPromotionType, setSelectedSubPromotionType] =
    useState<PromotionTypeInterface | null>(null);

  const [selectedAppliedType, setSelectedAppliedType] =
    useState<PromotionTypeInterface | null>(null);

  const [promotionTypeError, setPromotionTypeError] = useState<string | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [promotionSubTypeError, setPromotionSubTypeError] = useState<string | null>(null);

  const [promotionTypes, setPromotionTypes] = useState<{ value: string; label: string }[]>([]);

  const [subPromotionTypes, setSubPromotionTypes] = useState<{ value: string; label: string }[]>([]);

  const [selectedMenuTypeOption, setSelectedMenuTypeOption] =
    useState<MenuTypeOption | null>(null);

  const [selectedOption, setSelectedOption] = useState<ItemOptionType | null>(null);

  const [imageError, setImageError] = useState("");

  const [isPublic, setIsPublic] = useState(false);

  const [itemError, setItemError] = useState<string | null>(null);

  const [menuItemsOptionsForMenu, setMenuItemsOptionsForMenu] = useState([]);

  const [selectedItems, setSelectedItems] = useState<ItemOptionType[]>([]);

  const singleItemsList = useNormalizedMenuItems();
  const comboItemList = useSelector((state: any) => state.setMenu.setMenus);
  const customMenuItemList = useSelector((state: any) => state.customizeMenu.customizeMenu);

  const handlePromotionTypeChange = (option: PromotionTypeInterface | null) => {
    setSelectedPromotionType(option);
    setPromotionTypeError(null);
    setSelectedSubPromotionType(null); // Clear sub type when main type changes

    if (option && promotionTypesData?.promotionTypeList) {
      // Find the selected promotion type in the data
      const selectedTypeData = promotionTypesData.promotionTypeList.find(
        (type: any) => type.id === option.value
      );

      if (selectedTypeData && selectedTypeData.subTypes) {
        // Format sub types for the dropdown
        const formattedSubTypes = selectedTypeData.subTypes.map((subType: string) => ({
          value: subType,
          label: subType,
        }));
        setSubPromotionTypes(formattedSubTypes);
      } else {
        setSubPromotionTypes([]);
      }

      if (option.label === 'Fixed' || option.label === 'Percentage') {
        setValue('pointsToRupeeConversionRate', 0);
        setValue('rupeeToPointConversionRate', 0);
      }
    } else {
      setSubPromotionTypes([]);
    }
  };

  const handleSubPromotionTypeChange = (option: PromotionTypeInterface | null) => {
    setSelectedSubPromotionType(option);
    setPromotionTypeError(null);
    if (option) {
      if (option.value === 'Fixed' || option.value === 'Percentage') {
        setValue('pointsToRupeeConversionRate', 0);
        setValue('rupeeToPointConversionRate', 0);
      }
    }
  };

  const handleMenuTypeChange = (option: MenuTypeOption | null) => {
    setSelectedMenuTypeOption(option);
    if (option) {
      setItemError(null);
    }
  };

  const handleItemChange = (option: ItemOptionType | null) => {
    setSelectedOption(option);
    if (option) {
      setItemError(null);
    }
  };

  const handleAdd = () => {
    if (selectedOption) {
      setSelectedItems([...selectedItems, selectedOption]);
      setSelectedOption(null);
      setItemError(null);
    }
  };

  const handleDelete = (index: number) => {
    const updatedItems = [...selectedItems];
    updatedItems.splice(index, 1);
    setSelectedItems(updatedItems);
  };

  // const availableMenuItemsOptions = menuItemsOptionsForMenu.filter(
  //   (item: any) =>
  //     !selectedItems.some(
  //       (selectedItem: any) => selectedItem.itemId === item.itemId
  //     )
  // );
  const availableMenuItemsOptions = React.useMemo(() => {
    return menuItemsOptionsForMenu.filter(
      (item: any) =>
        !selectedItems.some(
          (selectedItem: any) => selectedItem.itemId === item.itemId
        )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuItemsOptionsForMenu, selectedItems, selectedMenuTypeOption]);

  const [trigger, { data: promotionTypesData, isLoading: isPromotionTypesLoading }] = useLazyGetPromotionTypeListQuery();

  const [triggerGetFilterTags, { data: filterTagsData, isLoading: isFilterTagsLoading }] = useLazyGetRestaurantFilterTagsQuery();

  // const [triggerMenuItems, { isLoading }] = useLazyGetMenuItemsListQuery();

  const [uploadLogoFileExtetion] =
    useUploadPromotionLogoFileExtntionHttpsMutation();

  const imageUploadCallback = (e: any) => {
    setUploadedImgDetails({
      ...uploadedImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtention: e.fileExtension,
    });
    setImageError("");
  };

  const [createPromotion] = useCreatePromotionMutation();

  const filterTagsOptions = React.useMemo(() => {
    if (isFilterTagsLoading || !filterTagsData) return [];

    const options: { value: string; label: string }[] = [];

    // Iterate over each category in filterTags
    Object.entries(filterTagsData.filterTags).forEach(([category, categoryData]) => {
      if (categoryData.tags && Array.isArray(categoryData.tags)) {
        categoryData.tags.forEach((tag) => {
          if (tag.show) {
            options.push({ value: tag.tag, label: `${tag.tag}` });
          }
        });
      }
    });

    return options;
  }, [filterTagsData, isFilterTagsLoading]);

  const onSubmit = async (data: FormData) => {
    if (!uploadedImgDetails.formData) {
      setImageError("Please upload an image");
      setIsSaving(false);
      return;
    }
    if (!selectedPrmotionType) {
      setPromotionTypeError("Promotion type must be selected");
      return;
    }
    setIsSaving(true);
    setPromotionTypeError(null);

    const imageUrl = await uploadImage(uploadLogoFileExtetion, {
      fileExtention: uploadedImgDetails.fileExtention,
      formData: uploadedImgDetails.formData,
    });

    const promotionData = {
      restaurantId: restaurantId,
      title: data.title,
      description: data.description,
      imageUrl: imageUrl,
      type: selectedPrmotionType?.label ?? "",
      subType: selectedSubPromotionType?.label ?? "",
      pointsToRupeeConversionRate: +data.pointsToRupeeConversionRate,
      rupeeToPointConversionRate: +data.rupeeToPointConversionRate,
      minimumBillTotal: +data.minimumBillTotal,
      value: +data.value,
      code: data.code,
      expiresAt: data.expiresAt,
      isPublic: data.isPublic,
      appliedTo: selectedAppliedType?.label ?? "",
      items: selectedItems.map((item: any) => ({
        itemId: item.itemId,
        type: item.itemType as "MenuItem" | "SetMenu" | "CustomMenu"
      })),
      filterTags: Array.isArray(data?.filterTags)
        ? data.filterTags.map((tag: any) => tag.value)
        : [],
    };
    try {
      await createPromotion(promotionData).unwrap();
      toast.success("Promotion Created Successfully");
      navigate("/configuration/promotions");
    } catch (error: any) {
      setIsSaving(false);
      toast.error(error);
      console.error("Failed to create promotion:", error);
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (restaurantId) {
      trigger(restaurantId);
    }
    if (promotionTypesData?.promotionTypeList) {
      const formatted = promotionTypesData.promotionTypeList.map((type: any) => ({
        value: type.id,
        label: type.displayName,
      }));
      setPromotionTypes(formatted);
      // const subTypes = promotionTypesData.promotionSubTypeList.map((type: any) => ({
      //   value: type.id,
      //   label: type.displayName,
      // }));
      // setSubPromotionTypes(subTypes);
    }
  }, [promotionTypesData, trigger, restaurantId]);

  useEffect(() => {
    if (restaurantId) {
      triggerGetFilterTags(restaurantId);
    }
  }, [restaurantId, triggerGetFilterTags]);


  useEffect(() => {
    if (!selectedMenuTypeOption) {
      setMenuItemsOptionsForMenu([]);
      return;
    }

    let sourceList = [];

    switch (selectedMenuTypeOption.value) {
      case "All":
        sourceList = [...singleItemsList, ...comboItemList, ...customMenuItemList];
        break;
      case "Single":
        sourceList = singleItemsList;
        break;
      case "SetMenu":
        sourceList = comboItemList;
        break;
      case "CustomMenu":
        sourceList = customMenuItemList;
        break;
      default:
        sourceList = [];
    }
    const menuItems = sourceList.map((item: any) => {
      let itemType = "";

      if (selectedMenuTypeOption.value === "All") {
        if (singleItemsList.some((i: any) => i.itemId === item.itemId)) {
          itemType = "MenuItem";
        } else if (comboItemList.some((i: any) => i.itemId === item.itemId)) {
          itemType = "SetMenu";
        } else if (customMenuItemList.some((i: any) => i.itemId === item.itemId)) {
          itemType = "CustomMenu";
        }
      } else if (selectedMenuTypeOption.value === "Single" || selectedMenuTypeOption.value === "MenuItem") {
        itemType = "MenuItem";
      } else if (selectedMenuTypeOption.value === "SetMenu") {
        itemType = "SetMenu";
      } else if (selectedMenuTypeOption.value === "CustomMenu") {
        itemType = "CustomMenu";
      }

      return {
        value: item.id,
        label: (
          <div style={{ display: "flex", justifyContent: "left", gap: "5%" }}>
            <img src={item.imageUrl} alt={item.displayName} width="30px" height="30px" />
            {item.displayName}
          </div>
        ),
        displayName: item.displayName,
        price: item.price,
        itemId: item.id,
        itemType: itemType,
        // imageUrl: item.imageUrl,
        imageUrl: Array.isArray(item.imageUrl) ? item.imageUrl[0] : item.imageUrl,
        allergenInformation: item.allergenInformation || [],
        foodAttributes: item.foodAttributes || [],
      };
    });
    setMenuItemsOptionsForMenu(menuItems);
  }, [selectedMenuTypeOption, singleItemsList, comboItemList, customMenuItemList]);


  if (isPromotionTypesLoading || isFilterTagsLoading) {
    return <div className="bg-white">
      <h4 className='p-3 mt-3'>Add Promotion</h4>
      <LoadingMessage />
    </div>;
  }

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card className="py-2">
        <CardHeader style={{ backgroundColor: "#fff" }}>
          <h4>Add Promotion</h4>
        </CardHeader>
        <CardBody>
          <form
            className="auth-login-form mt-2"
            onSubmit={handleSubmit(onSubmit)}
          >
            <IMGUploadComponent
              imageUrl={uploadedImgDetails.imgSrc}
              onUpload={imageUploadCallback}
            />
            {imageError && (
              <p className="text-danger ml-4 text-align-right">
                {imageError}
              </p>
            )}
            <hr />
            <ControlledRowTextField
              label="Title"
              inputName="title"
              inputType="text"
              placeholder="Enter Promotion Title"
              control={control}
            />
            <hr />
            <ControlledRowTextField
              label="Description"
              inputName="description"
              inputType="text"
              placeholder="Enter Promotion Description"
              control={control}
            />
            <hr />
            <Row className="align-items-center">
              <Col lg="4">
                <Label className="pt-1 form-label">Promotion Type</Label>
              </Col>
              <Col lg="8">
                <Select
                  value={selectedPrmotionType}
                  onChange={handlePromotionTypeChange}
                  options={promotionTypes}
                  placeholder="Select Prmotion Type"
                  isSearchable
                />
              </Col>
            </Row>
            {promotionTypeError && (
              <Row className="mt-2">
                <Col>
                  <div className="text-danger">{promotionTypeError}</div>
                </Col>
              </Row>
            )}
            {(selectedPrmotionType?.label === "Cash" || selectedPrmotionType?.label === "LoyaltyPoints") && (
              <>
                <hr />
                <Row className="align-items-center">
                  <Col lg="4">
                    <Label className="pt-1 form-label">Sub Promotion Type</Label>
                  </Col>
                  <Col lg="8">
                    <Select
                      value={selectedSubPromotionType}
                      onChange={handleSubPromotionTypeChange}
                      options={subPromotionTypes}
                      placeholder="Select Sub Promotion Type"
                      isSearchable
                    />
                  </Col>
                </Row>
                {promotionSubTypeError && (
                  <Row className="mt-2">
                    <Col>
                      <div className="text-danger">{promotionSubTypeError}</div>
                    </Col>
                  </Row>
                )}
                <hr />
                <ControlledRowTextField
                  label="Value"
                  inputName="value"
                  inputType="text"
                  placeholder="Enter Promotion Discount"
                  control={control}
                  rules={{
                    required: "Discount is required",
                    pattern: {
                      value: /^[0-9]*\.?[0-9]+$/,
                      message: "Only numbers are allowed",
                    },
                  }}
                />
                {errors.value && (
                  <span className="text-danger">
                    {errors.value.message as string}
                  </span>
                )}
                <hr />
                <ControlledRowTextField
                  label="Promotion Code"
                  inputName="code"
                  inputType="text"
                  placeholder="Enter Promotion Code"
                  control={control}
                />
                {errors.code && (
                  <span className="text-danger">
                    {errors.code.message as string}
                  </span>
                )}
                <hr />
                <ControlledRowTextField
                  label="Minimum Bill Total"
                  inputName="minimumBillTotal"
                  inputType="text"
                  placeholder="Enter Minimum Bill Total for Promotion"
                  control={control}
                  rules={{
                    required: "Minimum Bill for Promotion is required",
                    pattern: {
                      value: /^[0-9]*\.?[0-9]+$/,
                      message: "Only numbers are allowed",
                    },
                  }}
                />
                {errors.minimumBillTotal && (
                  <span className="text-danger">
                    {errors.minimumBillTotal.message as string}
                  </span>
                )}
                {(selectedPrmotionType?.label === "LoyaltyPoints") && (
                  <>
                    <hr />
                    <ControlledRowTextField
                      label="Points to Rupee Conversion Rate"
                      inputName="pointsToRupeeConversionRate"
                      inputType="text"
                      placeholder="Enter Points to Rupee Conversion Rate"
                      control={control}
                      rules={{
                        required: "Points to Rupee Conversion Rate is required",
                        pattern: {
                          value: /^[0-9]*\.?[0-9]+$/,
                          message: "Only numbers are allowed",
                        },
                      }}
                    />
                    {errors.pointsToRupeeConversionRate && (
                      <span className="text-danger">
                        {errors.pointsToRupeeConversionRate.message as string}
                      </span>
                    )}
                    <hr />
                    <ControlledRowTextField
                      label="Rupee to Point Conversion Rate"
                      inputName="rupeeToPointConversionRate"
                      inputType="text"
                      placeholder="Enter Rupee to Points Conversion Rate"
                      control={control}
                      rules={{
                        required: "Rupee to Point Conversion Rate is required",
                        pattern: {
                          value: /^[0-9]*\.?[0-9]+$/,
                          message: "Only numbers are allowed",
                        },
                      }}
                    />
                    {errors.rupeeToPointConversionRate && (
                      <span className="text-danger">
                        {errors.rupeeToPointConversionRate.message as string}
                      </span>
                    )}
                  </>
                )}
                <hr />
                <Row>
                  <Col lg="4">
                    <Label className="form-label" htmlFor="expriesAt">
                      Expires At
                    </Label></Col>
                  <Col lg="8">
                    <Controller
                      control={control}
                      name="expiresAt"
                      rules={{ required: "Expiry date is required" }}
                      render={({ field }) => (
                        <Flatpickr
                          {...field}
                          id="expriesAt"
                          placeholder="Select Expiry Date"
                          className="form-control"
                          options={{
                            enableTime: false,
                            noCalendar: false,
                            dateFormat: "Y-m-d",
                            minDate: new Date(),
                          }}
                          onChange={(date: string) => field.onChange(date[0])}
                        />
                      )}
                    />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col lg="4">
                    <Label
                      className="form-check-label"
                      htmlFor="supportsPreOrdering"
                    >
                      Is Public
                    </Label>
                  </Col>
                  <Col lg="8">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="isPublic"
                      checked={isPublic}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setIsPublic(event.target.checked);
                        setValue("isPublic", event.target.checked);
                      }}
                    />
                  </Col>
                </Row>
              </>
            )}
            <hr />
            <Row className="align-items-center">
              <Col lg="4">
                <Label className="pt-1 form-label">Applied To</Label>
              </Col>
              <Col lg="8">
                <Select
                  value={selectedAppliedType}
                  onChange={setSelectedAppliedType}
                  options={ApplyTypes}
                  placeholder="Select Applied To"
                  isSearchable
                />
              </Col>
            </Row>

            {/* Show Filter Tags section for FilterTags */}
            {(selectedAppliedType?.label === "FilterTags") && (
              <>
                <hr />
                <ControlledSelect
                  label={"Filter Tags"}
                  inputName={"filterTags"}
                  control={control}
                  isMulti={true}
                  optionsList={filterTagsOptions}
                />
              </>
            )}
          </form>

          {/* Show Save button for FilterTags or All (but not Items only) */}
          {(selectedAppliedType?.label === "FilterTags" || selectedAppliedType?.label === "All"
          ) && (
              <div className="d-flex justify-content-end mt-4 mb-2">
                {isSaving ? (
                  <ButtonComponent
                    icon={<FontAwesomeIcon icon={faSpinner} spin />}
                    type="submit"
                    titel="Saving..."
                    isDisabled={true}
                  />
                ) : (
                  <ButtonComponent
                    type="submit"
                    titel="Save"
                    onClick={handleSubmit(onSubmit)}
                  />
                )}
              </div>
            )}
        </CardBody>
      </Card>

      {/* Show Menu Items section for Items */}
      {(selectedAppliedType?.label === "Items") && (
        <Card className="mt-3">
          <CardBody>
            <Row className="align-items-center mt-3">
              <Col sm={4}>
                <Label className="pt-1 form-label">Menu Items</Label>
              </Col>
              <Col sm={2}>
                <Select
                  value={selectedMenuTypeOption}
                  onChange={handleMenuTypeChange}
                  options={MenuTypeForMenu}
                  placeholder="Menu Type"
                  isSearchable
                />
              </Col>
              <Col sm={4}>
                <Select
                  value={selectedOption}
                  onChange={handleItemChange}
                  options={availableMenuItemsOptions}
                  placeholder={"Search menu item"}
                  isDisabled={!selectedMenuTypeOption}
                  loadingMessage={() => "Loading menu items..."}
                  noOptionsMessage={() => "No items found"}
                  filterOption={customFilterOption}
                />
              </Col>
              <Col sm={2} className="text-right">
                <ButtonComponent
                  titel="+Add Item"
                  type="button"
                  onClick={handleAdd}
                  isDisabled={!selectedMenuTypeOption || !selectedOption}
                />
              </Col>
            </Row>
            {itemError && (
              <Row className="mt-2">
                <Col>
                  <div className="text-danger">{itemError}</div>
                </Col>
              </Row>
            )}
            <hr />
            <h5>Selected Items</h5>
            <Table bordered className="mt-3" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Price (Rs.)</th>
                  {/* <th>Food Attributes</th>
                  <th>Allergen Information</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedItems.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="d-flex gap-3">{item.displayName}</div>
                    </td>
                    <td>{item.price}</td>
                    {/* <td>
                      <div className="d-flex gap-2">
                        {item.foodAttributes?.length ? (
                          item.foodAttributes.map((attribute, i) => (
                            <img
                              key={i}
                              src={getImageUrl(attribute)}
                              alt={attribute}
                              width="24"
                              height="24"
                              title={attribute}
                            />
                          ))
                        ) : (
                          <span>None</span>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        {item.allergenInformation?.length ? (
                          item.allergenInformation.map((attribute, i) => (
                            <img
                              key={i}
                              src={getImageUrl(attribute)}
                              alt={attribute}
                              width="24"
                              height="24"
                              title={attribute}
                            />
                          ))
                        ) : (
                          <span>None</span>
                        )}
                      </div>
                    </td> */}
                    <td>
                      <Button variant="light" onClick={() => handleDelete(index)}>
                        <FontAwesomeIcon icon={faTrash} color="#F24E1E" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {/* Save button for Items section */}
            <div className="d-flex justify-content-end mt-4 mb-2">
              {isSaving ? (
                <ButtonComponent
                  icon={<FontAwesomeIcon icon={faSpinner} spin />}
                  type="submit"
                  titel="Saving..."
                  isDisabled={true}
                />
              ) : (
                <ButtonComponent
                  type="submit"
                  titel="Save"
                  onClick={handleSubmit(onSubmit)}
                />
              )}
            </div>
          </CardBody>
        </Card>
      )}
    </>
  )
}

export default AddPromotion;